import type { GatsbyLinkProps, Link } from 'gatsby'
import React, { type PropsWithChildren } from 'react'

type TagPropsBase = PropsWithChildren

type DefaultProps = {
  as?: React.ElementType
} & React.HTMLAttributes<HTMLElement>

type InternalLinkProps = {
  as: typeof Link
  to: string
} & Omit<GatsbyLinkProps<any>, 'to'>

type TagProps = TagPropsBase & (InternalLinkProps | DefaultProps)

export const Tag: React.FC<TagProps> = ({
  as: TagContainer = 'div',
  children,
  ...props
}) => (
  <TagContainer
    className="inline-flex min-h-6 items-center justify-center rounded-[2px] border-[1px] border-solid border-grey-200 px-1.5 text-075 leading-auto hover:border-grey-900 hover:bg-slate-50"
    {...props}
  >
    {children}
  </TagContainer>
)
